import { render } from "./BetHistory.vue?vue&type=template&id=0135535c&scoped=true&ts=true"
import script from "./BetHistory.vue?vue&type=script&lang=ts"
export * from "./BetHistory.vue?vue&type=script&lang=ts"

import "./BetHistory.vue?vue&type=style&index=0&id=0135535c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0135535c"]])

export default __exports__